@import "../../../globalStyles/commons";

:host {
  display: block;
}


.empty-state {
  container: emptystate / inline-size;
  padding: var(--spacing-03);
  height: 100%;
  max-width: var(--container-lg);
  margin: auto;
}

.empty-state-container {
  display: flex;
  height: 100%;
  justify-content: center;
  gap: var(--spacing-08);
  align-items: center;
}

.illustration {
  height: 100%;
  display: flex;

  svg {
    height: 100%;
  }

  --empty-state-outline: #{v(--color-brand-primary)};
  --empty-state-bg-primary: #{v(--color-brand-secondary)};
  --empty-state-bg-secondary: #{v(--color-brand-secondary-40)};
  --empty-state-bg-tertiary: #{v(--color-brand-secondary-30)};

  --empty-state-text: var(--text-primary);
  --empty-state-bg-surface: var(--background);

  --empty-state-green: #{v(--color-success-50)};
}

:host-context([data-theme="dark"]) {
  .illustration {
    --empty-state-bg-secondary: #{v(--color-brand-secondary-50)};
    --empty-state-bg-tertiary: #{v(--color-brand-secondary-90)};
  }
}


.content {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .title {
    @include font-style(text-md);
    font-weight: v(--font-weight-semi-bold);
    margin-bottom: v(--spacing-02);
    color: var(--text-color, var(--text-primary))
  }

  .description {
    @include font-style(text-sm);
    margin-bottom: v(--spacing-04);
    color: var(--text-color, var(--text-secondary))
  }
}

:host(.content-center) .content {
  align-items: center;
}

@container emptystate (min-width: 672px) {
  .empty-state {
    .illustration {
      width: 50%;
    }

    .content {
      width: 50%;
    }
  }
}

@container emptystate (max-width: 671px) {
  .empty-state {
    .empty-state-container {
      flex-direction: column;
      gap: var(--spacing-05);

      .illustration {
        height: auto;
        width: 100%;
        justify-content: center;
      }
    }
  }
}

